import { AppLink, asCurrency, asDate, asTimelessDate, colors, Flex, PrimaryButton, Tile, TileField } from 'lqx-react';
import * as React from 'react';
import { Transaction } from 'src/app/pages/inmatch/api';
import { CustomerSupplier } from '../../../../../../common/inmatch';
import { Can } from 'src/app/services/can';
import { UserEntitlementCatalogs } from 'src/app/models/UserEntitlements';

export const UacTransactionTile = ({ transaction, move, style } : { 
        transaction : Transaction,
        move: (payment: Transaction) => void,
        style 
    }) => { 

        return (
            <Tile
                style={style}
                color={colors.yellow}
                leftTitle="UAC"
                left={<TileField> { transaction.isOneSided && 'One-sided' } </TileField>}
                title={asCurrency(transaction.amount, transaction.currency)}
                aboveTitle={<CustomerSupplier customer={ transaction.customer } supplier={ transaction.supplier } payorAgent={ transaction.payorAgent } />}
                extra={<>
                    <Flex grow />
                    <Flex alignCenter>
                        {
                        Can(UserEntitlementCatalogs.BankEntryWrite) && 
                        <PrimaryButton onClick={() => move(transaction)}>
                            Send for Match
                        </PrimaryButton>
                        }
                    </Flex>
                </>}
            >
                <TileField label="Value Date">
                    {asTimelessDate(transaction.valueDate)}
                </TileField>

                <TileField label="Cash Received">
                    {asCurrency(transaction.unreconciledAmount, transaction.currency)}
                </TileField>

                { !transaction.isOneSided &&
                    <TileField>
                        <AppLink href={`/bank-transactions/details/${transaction.id}`} returnUrl>View Details</AppLink>
                    </TileField>
                }
            </Tile>
        )
    }